var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{ref:"main-lobby-container",staticClass:"pa-0 main_lobby",attrs:{"fluid":""}},[_c('main-image')],1)}
var staticRenderFns = []

export { render, staticRenderFns }